import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Header = ({ logo, buttons }) => {
  const navigate = useNavigate(); // For navigation

  return (
    <header className="flex items-center justify-between p-4 bg-white shadow-gray-700 shadow-xl flex-wrap">
      {/* Logo */}
      {/* <img src={logo} alt="Logo" className="h-20" /> */}
      <img src={logo} alt="Logo" className="h-20" />

      {/* Dynamic Buttons */}
      <div className="flex gap-4 flex-wrap">
        {buttons.map((button, index) => {
          if (button.dropdown) {
            return (
              <div key={index} className="relative group">
                <button
                  className={`px-4 py-2 rounded-md font-medium transition ${button.color} hover:opacity-80 flex items-center gap-1`}
                >
                  {button.text}
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                </button>
                <div className="absolute right-0 pt-2 w-48 hidden group-hover:block z-50">
                  <div className="bg-white rounded-md shadow-lg border border-gray-100 py-1">
                    {button.dropdown.map((item, i) => (
                      <button
                        key={i}
                        onClick={() => {
                          if (item.onClick) item.onClick();
                          else navigate(item.route);
                        }}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition"
                      >
                        {item.text}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            );
          }

          return (
            <button
              key={index}
              onClick={() => {
                if (button.onClick) {
                  button.onClick(); // Call function if provided
                } else {
                  navigate(button.route); // Default navigation
                }
              }}
              className={`px-4 py-2 rounded-md font-medium transition ${button.color} hover:opacity-80`}
            >
              {button.text}
            </button>
          );
        })}
      </div>
    </header>
  );
};

export default Header;
